import { useEffect, useState } from 'react'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { actionClientList, resetClientListResponse } from '../../routes/app/auth/my_profile/store'
import { useForm } from 'react-hook-form'
import ErrorLabel from '../error_label'
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from '../../common/app_constant'
import { actionAddEnquiryForm, resetEnquiryAddFormResponse } from '../../common/store'
import { toast } from 'react-hot-toast'
import $ from 'jquery';


export default function RecommendedPolicy() {

    const navigation = useNavigate()
    const dispatch = useDispatch()

    const { clientList } = useSelector((state) => ({
        ...state.MyProfileStore
    }))

    const { EnquiryAdd } = useSelector((state) => ({
        ...state.commonStore
    }))


    const {
        register,
        formState: { errors },
        handleSubmit, getValues, setValue, watch, control, reset } =
        useForm({
            defaultValues: {}
        });

    const [sliderRef, setSliderRef] = useState(null)
    const [isOpen, setIsopen] = useState(false)
    const [clientListArr, setClientList] = useState([])
    const [selectedEnquiryType, setSelectedEnqueryType] = useState('')


    useEffect(() => {
        dispatch(actionClientList())
    }, [])

    const sliderSettings = {
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const recommendedPolicyArr = [
        {
            id: 1,
            title: 'Casualty Package Policy',
            content: 'Insure a broad category of coverage against loss of property, damage, or other liabilities.',
            class: 'casualty',
            value: 'casualty_policy',

        },
        {
            id: 2,
            title: 'Motor Fleet Policy',
            content: 'Cover all your commercial or personal vehicles under one policy. ',
            class: 'bike',
            value: 'motor_fleet_policy',

        },
        {
            id: 3,
            title: 'Group Mediclaim Policy',
            content: 'Ensure well-being for financial and practical reasons with a Group Mediclaim.',
            class: 'group',
            value: 'group_mediclaim_policy'

        },
        {
            id: 4,
            title: 'Office Package Policy',
            content: 'Secure your workforce, management, infrastructure and a variety of assets with an Office Package Policy.',
            class: 'office',
            value: 'office_package_policy'
        }
    ]

    useEffect(() => {
        if (clientList !== null) {
            dispatch(resetClientListResponse())
            if (clientList.result === true) {
                setClientList(clientList.response)
            } else {
                switch (clientList.status) {
                    default:
                }
            }
        }
    }, [clientList])

    useEffect(() => {
        if (EnquiryAdd !== null) {
            dispatch(resetEnquiryAddFormResponse())
            if (EnquiryAdd.result === true) {
                setIsopen(false)
                reset()
                toast.success(EnquiryAdd.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
                $("#app-body").attr("style", "");
                $("#root").removeClass("modal-open");
                $(".modal-backdrop").remove();
            } else {
                setIsopen(false)
                switch (EnquiryAdd.status_code) {
                    case 400:
                        toast.error(EnquiryAdd.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [EnquiryAdd])


    const renderData = () => {
        var arrData = []
        recommendedPolicyArr != null && recommendedPolicyArr.length ?
            recommendedPolicyArr.map((item, index) => {
                arrData.push(
                    <div class={`card mt-2 ${item.class} _insurance-card`} style={{ marginBottom: 10 }}>
                        <div class="card-body ">
                            <div class="d-flex">
                                <h6 class="my-auto text-shadow">{item.title}</h6>
                                <span class="badge rounded-pill bg-primary ms-auto lh-lg my-auto cursor-pointer" data-bs-toggle="modal" data-bs-target="#enquiry_one"
                                    onClick={() => {
                                        setIsopen(true)
                                        setSelectedEnqueryType(item.value)
                                    }}
                                >Enquiry</span>
                            </div>
                            <p class="mt-2 mb-0 text-shadow">{item.content}</p>
                        </div>
                    </div>
                )

            })
            :
            <></>
        return arrData
    }

    const generateCompanyList = () => {
        var menu = [];
        if (clientListArr != null && clientListArr.length > 0) {
            clientListArr.forEach(function (child, labelIndex) {
                menu.push(
                    <option key={labelIndex} value={child.id}>
                        {child.name}
                    </option>
                );
            });
        }
        return menu;
    };

    const onSubmit = async (data) => {
        var clientId = ''

        if (clientListArr.length > 1) {
            clientId = data.client_id
        } else {
            clientId = clientListArr[0].id

        }
        dispatch(actionAddEnquiryForm({
            type: selectedEnquiryType,
            message: data.message,
            client_id: clientId
        }))
    }

    return (
        <>
            <span className="fw-bold">Enquiry</span>
            <div className='content mb-4'>
                <Slider autoplay={100} vertical={true} verticalSwiping={true} ref={setSliderRef} {...sliderSettings}>
                    {renderData()}
                </Slider>
            </div>
            <div
                style={{ display: isOpen === true ? 'block' : 'none' }}

                class="modal fade" id="enquiry_one" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="enquiry_oneLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="enquiry_oneLabel">Enquiry</h5>
                            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                setIsopen(false)

                            }}>
                                <i className="fa fa-close" />
                            </button>
                        </div>
                        <div class="modal-body">
                            <form
                                noValidate
                                autoComplete="off"
                            >
                                <div class="mt-1">
                                    <label for="msg" class="form-label">Message</label>
                                    <textarea
                                        rows={3}
                                        className="form-control"
                                        id="message"
                                        {...register(
                                            "message", {
                                            required: "This is required.",
                                            minLength: {
                                                value: 10,
                                                message: "Address cannot be less than 10-chars."
                                            },
                                            maxLength: {
                                                value: 500,
                                                message: "Address cannot be greater than 500-chars."
                                            },
                                        }
                                        )}
                                    />
                                    {errors.message && (
                                        <ErrorLabel
                                            message={
                                                errors
                                                    .message
                                                    ?.message
                                            }
                                        />
                                    )}
                                </div>
                                {
                                    clientListArr.length > 1 ?
                                        <div class="mt-3">
                                            <label htmlFor="company_name" className="form-label">
                                                Company Name<span className="text-danger">*</span>
                                            </label>
                                            <select
                                                id="client_id"
                                                className="form-control form-select"
                                                {...register(
                                                    "client_id",
                                                    {
                                                        required: "This is required."
                                                    }
                                                )}
                                            >
                                                <option value="">Company Name</option>
                                                {generateCompanyList()}
                                            </select>
                                            {errors.client_id && (
                                                <ErrorLabel
                                                    message={
                                                        errors
                                                            .client_id
                                                            ?.message
                                                    }
                                                />
                                            )}
                                        </div> : <></>

                                }
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" onClick={handleSubmit(onSubmit)}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}